import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-item-dialog',
  templateUrl: './remove-item-dialog.component.html',
  styleUrls: ['./remove-item-dialog.component.scss']
})
export class RemoveItemDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveItemDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
